export enum FormDataMappingSource {
  DefaultValue = 'DefaultValue',
  ODSPerson = 'ODS.Person',
  ODSEmployee = 'ODS.Employee',
  PostData = 'PostData'
}